module.exports = __webpack_public_path__ + "static/media/fox.2a3b46a3.jpg";